// CSS styles for article content
export default function ProseStyles() {
  return (
    <style>{`
      .prose-custom h2 {
        font-family: var(--font-heading);
        font-size: 1.5rem;
        font-weight: 700;
        color: oklch(var(--foreground-950));
        margin-top: 2.5rem;
        margin-bottom: 1rem;
        line-height: 1.3;
        scroll-margin-top: 6rem;
      }
      .prose-custom h3 {
        font-family: var(--font-heading);
        font-size: 1.2rem;
        font-weight: 600;
        color: oklch(var(--foreground-900));
        margin-top: 2rem;
        margin-bottom: 0.75rem;
        line-height: 1.4;
      }
      .prose-custom p {
        margin-bottom: 1.25rem;
        line-height: 1.75;
        font-size: 0.95rem;
        color: oklch(var(--foreground-700));
      }
      .prose-custom ul, .prose-custom ol {
        margin-bottom: 1.25rem;
        padding-left: 1.5rem;
      }
      .prose-custom li {
        margin-bottom: 0.5rem;
        line-height: 1.7;
        font-size: 0.95rem;
        color: oklch(var(--foreground-700));
      }
      .prose-custom strong {
        color: oklch(var(--foreground-900));
        font-weight: 600;
      }
      .prose-custom a {
        color: oklch(var(--accent-600));
        text-decoration: underline;
        text-underline-offset: 3px;
      }
      .prose-custom a:hover {
        color: oklch(var(--accent-700));
      }
      .prose-custom blockquote {
        border-left: 3px solid oklch(var(--accent-500));
        padding-left: 1.25rem;
        margin: 1.5rem 0;
        font-style: italic;
        color: oklch(var(--foreground-600));
        background: oklch(var(--background-100));
        padding: 1rem 1.25rem;
        border-radius: 0 0.5rem 0.5rem 0;
      }
      .prose-custom .inline-cta {
        display: inline-flex;
        align-items: center;
        gap: 0.375rem;
        background: oklch(var(--accent-100) / 0.7);
        color: oklch(var(--accent-700));
        padding: 0.25rem 0.75rem;
        border-radius: 9999px;
        font-size: 0.8rem;
        font-weight: 500;
        text-decoration: none;
        white-space: nowrap;
      }
      .prose-custom .inline-cta:hover {
        background: oklch(var(--accent-200) / 0.8);
      }
      .prose-custom table {
        width: 100%;
        border-collapse: collapse;
        margin: 1.5rem 0;
        font-size: 0.9rem;
      }
      .prose-custom th {
        text-align: left;
        padding: 0.75rem 1rem;
        background: oklch(var(--background-100));
        font-weight: 600;
        color: oklch(var(--foreground-900));
        border-bottom: 2px solid oklch(var(--background-200));
      }
      .prose-custom td {
        padding: 0.75rem 1rem;
        border-bottom: 1px solid oklch(var(--background-200));
        color: oklch(var(--foreground-700));
      }
      @media (max-width: 768px) {
        .prose-custom h2 { font-size: 1.3rem; }
        .prose-custom p, .prose-custom li { font-size: 0.9rem; }
      }
    `}</style>
  );
}